/**
 * Change display of step numbers from 'N of N' to 'N / N'
 *
 * @param {number} nextStep - next step index
 * @param {number} totalSteps - amount of steps
 * */

export const changeStepNumbersDisplay = (nextStep, totalSteps) => {
    // Find step numbers element
    const stepNumsEl = document.querySelector('.introjs-helperNumberLayer');

    // Changes text "1 of 5" to "1 / 5" within CSS
    if (stepNumsEl) {
        stepNumsEl.setAttribute('data-step-nums', `${nextStep + 1} / ${totalSteps}`)
    }
};